<ng-content select="[menuBar]"></ng-content>
<div class="page-content-wrapper">
  <div class="page-content-container">
    <div class="page-scroll-content" id="main-scroll-container">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
<div class="bottom-rim-spacer"></div>
<ng-content select="[fixed]"></ng-content>
